export const LOADING = 'loading';
export const STORES = 'stores';
export const CONTACTS = 'contacts';
export const ADDRESSES = 'addresses';
export const LOCATION_ID = 'locationId';
export const PICKUP_ID = 'pickupId';
export const ADDRESS_ID = 'addressId';
export const SHIPPING_TYPE = 'shippingType';
export const STORE_MARKER = 'storeMarker';
export const SHIPPING_RATES = 'shippingRates';